:host {
  height: auto;
  width: 70%;
}

gz-form-field {
  &::part(form-field-label) {
    min-width: 220px;
    max-width: 220px;
  }
}

.fallback-checkbox {
  margin-left: 52px !important;
  margin-top: 7px;
}

.second-dropdown {
  margin-left: 52px;
}

.flex-group {
  display: flex;
  align-items: flex-start;
  margin-left: 27px;
}

gz-info-box {
  padding: var(--spacer) 0 0;
  line-height: 18px;
  --info-box-max-width: 846px;
}

.info-box-style::part(container) {
  padding: unset;
  width: 870px;
}

.automatic-text-spacing {
  span {
    display: block;
  }
}

.form-subtitle-info {
  margin-top: calc(var(--spacer) * 2.5);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}
